<template>
  <div>
    <w-panel>
      <div slot="header-tool-left" class="title-h3">
        변경이력
        <el-radio-group v-model="activeDeviceTypeTab" class="ordinary mr-l15" v-if="isTypeTab">
          <el-radio-button label="device">
            <p style="width: 50px;">장비</p>
          </el-radio-button>
          <el-radio-button label="interface">인터페이스</el-radio-button>
        </el-radio-group>
      </div>
      <div slot="header-tool-left"></div>
      <div slot="header-tool-right">
        <el-date-picker
          class="mr-r4"
          size="small"
          style="width: 220px;"
          :editable="false"
          type="daterange"
          v-model="dateRange"
          :range-separator="defaultDateRangeOptions.rangeSeparator"
          :start-placeholder="defaultDateRangeOptions.startPlaceholder"
          :end-placeholder="defaultDateRangeOptions.endPlaceholder"
          :picker-options="defaultDateRangeOptions.pickerOptions"
          :defaultTime="defaultDateRangeOptions.defaultTime"
          format="yyyy-MM-dd"
          :clearable="false"
        >
        </el-date-picker>
        <el-button size="small" @click="exportChangeHistInfo"><img src="@/assets/img/icons/excel.png" style="position:relative;top:3px;left:-2px" /> 엑셀출력</el-button>
        <w-header-search-button @click="showSearchTool = !showSearchTool"></w-header-search-button>
      </div>
      <el-table-wrapper
        slot="body"
        ref="changeHistTable"
        v-loading="isLoading"
        :data="dataList"
        :total="total"
        :column-default="columnDefault"
        remote
        pagination
        @condition-change="onTableConditionChange"
        :columns="changeHistColumns"
        :show-custom-header="true"
        :show-search-tool="showSearchTool"
        style="width:100%;"
      >
        <template #detail-info="scope">
          <span @click="onClickDetailButton(scope.row)"><i class="far fa-search-plus c-pointer"/></span>
        </template>
      </el-table-wrapper>
    </w-panel>
    <w-detail-change-hist-popup ref="detailChangeHistPopup" :selectHistParams="selectHistParams"></w-detail-change-hist-popup>
    <w-dbms-change-hist-popup ref="dbmsChangeHistPopup" :selectHistParams="selectHistParams"></w-dbms-change-hist-popup>
    <w-vms-change-hist-popup ref="vmsChangeHistPopup" :selectHistParams="selectHistParams"></w-vms-change-hist-popup>
    <w-ap-controller-change-hist-popup ref="apControllerChangeHistPopup" :selectHistParams="selectHistParams"></w-ap-controller-change-hist-popup>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { cloneDeep, isNil, eq } from 'lodash';
import commonAPI from '@/api/config/common';
import moment from 'moment';
import { columnDefault } from '@/constants/table';
import { getValueAfterCheckEmpty, EMPTY_TEXT } from '@/utils/string';
import { defaultDateRangeOptions, getDateToString } from '@/utils/date';
import FileApi from '@/api/common/file';
import msgUtil from '@/utils/message';
import WDetailChangeHistPopup from '../components/DetailChangeHistPopup';
import WDbmsChangeHistPopup from '../components/DbmsChangeHistPopup';
import WVmsChangeHistPopup from '../components/VmsChangeHistPopup';
import WApControllerChangeHistPopup from '../components/ApControllerChangeHistPopup';

const endDatetime = moment();
endDatetime.hours(23);
endDatetime.minutes(59);
endDatetime.seconds(59);
const startDatetime = endDatetime.clone().subtract(7, 'days');
startDatetime.hours(0);
startDatetime.minutes(0);
startDatetime.seconds(0);

export default {
  name: 'WChangeHistView',
  props: {
    activeTab: {
      type: String,
    },
    nodeParams: {
      type: Object,
    },
    titleName: {
      type: String,
    },
  },
  components: {
    WDetailChangeHistPopup,
    WDbmsChangeHistPopup,
    WVmsChangeHistPopup,
    WApControllerChangeHistPopup,
  },
  data() {
    return {
      columnDefault,
      total: null,
      showSearchTool: false,
      selectHistParams: {},
      dataList: [],
      isLoading: false,
      params: {
        objId: null,
      },
      activeDeviceTypeTab: 'device',
      defaultDateRangeOptions,
      dateRange: [startDatetime.toDate(), endDatetime.toDate()],
      changeHistColumns: [
        {
          prop: 'typeName',
          label: '변경타입',
          remoteProp: 'oct.type_name',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'chngGrpMessage',
          label: '변경 메시지',
          remoteProp: 'ocgh.chng_grp_message',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'checkDatetime',
          label: '변경감지시각',
          remoteProp: 'ocgh.check_datetime',
          width: 300,
          sortable: true,
          searchType: 'date',
          searchable: true,
          formatter: this.convertDatetime,
        },
        {
          width: 100,
          prop: 'detailHist',
          label: '상세보기',
          scopedSlot: 'detail-info',
          sortable: true,
        },
      ],
      interfaceHistColumn: {
        prop: 'objName',
        label: '장비명',
        remoteProp: 'o.obj_name',
        sortable: true,
        searchable: true,
      },
    };
  },
  computed: {
    ...mapGetters(['selectedNode']),
    //  WNMS 추가: NETDEVICE 일 경우에 추가하여 WIRELESS_DEVICE > AP_CONTROLLER 에도 인터페이스가 있어 수정
    isTypeTab() {
      return this.nodeParams.objDefineId === 'NETDEVICE' || this.nodeParams.objtypeId === 'AP_CONTROLLER';
    },
  },
  watch: {
    nodeParams: {
      handler() {
        this.params.objId = this.selectedNode.obj.objId;
        this.loadData();
      },
      immediate: true,
    },
    activeTab: {
      handler() {
        this.params.objId = this.selectedNode.obj.objId;
        this.loadData();
      },
    },
    dateRange: {
      handler() {
        this.loadData();
      },
    },
    activeDeviceTypeTab: {
      handler() {
        this.$refs.changeHistTable.clearFilter();
        this.loadData();
      },
    },
  },
  methods: {
    /**
     * [loadData datepicker에 설정된 날짜 기준으로 데이터를 로드한다.]
     * @author yelim
     * @return {[type]} [description]
     */
    loadData() {
      const me = this;
      if (!isNil(me.params.objId) && this.activeTab === this.$options.name) {
        const endDate = moment(me.dateRange[1]).add(1, 'seconds');
        const loadParams = {
          startDatetime: me.dateRange[0].getTime(),
          endDatetime: endDate.toDate().getTime(),
        };
        if (this.isTypeTab && this.activeDeviceTypeTab === 'interface') {
          loadParams.parentObjId = me.params.objId;
          loadParams.objDefineId = 'NETINTERFACE';
          const tempArr = cloneDeep(me.changeHistColumns);
          if (me.changeHistColumns.length <= 4) {
            tempArr.unshift(this.interfaceHistColumn);
          }
          me.changeHistColumns = [];
          me.$nextTick(() => {
            me.changeHistColumns = tempArr;
          });
        } else {
          loadParams.objId = me.params.objId;
          if (me.changeHistColumns.length > 4) {
            const tempArr = cloneDeep(me.changeHistColumns);
            tempArr.splice(0, 1);
            me.changeHistColumns = [];
            me.$nextTick(() => {
              me.changeHistColumns = tempArr;
            });
          }
        }
        const tableParams = this.$refs.changeHistTable.getParameter();
        const params = Object.assign(tableParams, loadParams);
        commonAPI.getChangeHistList(params).then((response) => {
          if (response.data.success) {
            me.dataList = response.data.data;
            me.total = response.data.total;
          }
        });
      }
    },
    convertDatetime(row, column, value) {
      if (isNil(value)) {
        return EMPTY_TEXT;
      }
      return getDateToString(value);
    },
    getTableValueAfterCheckEmpty(row, column, value) {
      return getValueAfterCheckEmpty(value);
    },
    exportChangeHistInfo() {
      const me = this;
      const tableParams = this.$refs.changeHistTable.getParameter();
      delete tableParams.start;
      delete tableParams.limit;
      const loadParams = {
        objId: me.params.objId,
        startDatetime: me.dateRange[0],
        endDatetime: me.dateRange[1],
        data: `${me.titleName}_변경이력정보_`,
        ...tableParams,
      };
      if (this.nodeParams.objDefineId === 'NETDEVICE' && this.activeDeviceTypeTab === 'interface') {
        loadParams.parentObjId = me.params.objId;
        loadParams.objDefineId = 'NETINTERFACE';
      } else {
        loadParams.objId = me.params.objId;
      }

      commonAPI
        .exportChangeHistList(loadParams)
        .then((response) => {
          if (response.data.success && !isNil(response.data.data)) {
            FileApi.downloadExportedExcelFile(response.data.data);
          } else {
            this.$message(msgUtil.getResultMsgData('출력', '엑셀', false));
          }
        })
        .catch(() => {
          this.$message(msgUtil.getResultMsgData('출력', '엑셀', false));
        });
    },
    onTableConditionChange() {
      this.loadData();
    },
    /**
     * 상세보기 클릭시 DBMS인 경우 DBMS detail 팝업
     * 가상화인 경우 VMS detail 팝업
     * AP 컨트롤러 > 무선AP 이력인 경우 ApController 팝업
     * 이외의 경우 일반 팝업
     * @param  {[type]} record [description]
     * @return {[type]}        [description]
     * @author jda
     */
    onClickDetailButton(record) {
      this.selectHistParams = {
        typeKey: record.typeKey,
        typeName: record.typeName,
        objId: this.params.objId,
        chngGrpSeqNumber: record.chngGrpSeqNumber,
        checkDatetime: record.checkDatetime,
        dateRange: this.dateRange,
      };
      if (this.isTypeTab && this.activeDeviceTypeTab === 'interface') {
        this.selectHistParams.objId = record.objId;
      }
      if (eq(this.selectedNode.obj.objDefineId, 'DBMS')) {
        // DBMS 전용 팝업을 띄워야하는 경우
        this.$refs.dbmsChangeHistPopup.open();
      } else if (eq(this.selectedNode.obj.objDefineId, 'VMS_OBJECT')) {
        this.$refs.vmsChangeHistPopup.open();
      } else if (eq(this.selectedNode.obj.objtypeId, 'AP_CONTROLLER') && record.typeKey === 'WIRELESS_AP_CONFIG') {
        // AP 컨트롤러 전용, 무선AP 비교 이력 팝업을 띄워야 하는 경우
        this.$refs.apControllerChangeHistPopup.open();
      } else {
        this.$refs.detailChangeHistPopup.open();
      }
    },
  },
};
</script>
<style module>
.margin_r {
  margin-right: 4px;
}
</style>



// WEBPACK FOOTER //
// src/views/config/node/common/ChangeHistView.vue